import React from "react";

const AffirmSnippet = () => {
  return (
    <p>
      <b>Affirm:</b>
      {`{{AFFIRMSNIPPET}}`}{" "}
    </p>
  );
};

export default AffirmSnippet;
